import * as z from "zod";
import { requiredString } from "components/form/utils";

export const resultsSchema = z.object({
    solution_overview: requiredString(),
    obstacles: requiredString(),
    methodology: requiredString(),
    achievements: requiredString(),
});
